<template>
    <v-layout>
        <v-flex xs12>
            <v-card v-bind:class="[itemDefinition.renderAsReport ? 'carnot-custom-report': null]" :light="itemDefinition.renderAsReport&&itemDefinition.whiteMode">
                <v-card-title class="accent white--text title" v-if="!embeddedMode">
                    {{itemDefinition.title|translate}}
                </v-card-title>
                <v-card-text style="padding-top: 0; bottom: 0;" v-if="!embeddedMode">
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="range"></date-range-selector>
                            <div style="width: 360px" v-if="itemDefinition.hasEquipmentSelector">
                                <equipment-selector v-model="equip" :typeFilter="itemDefinition.equipmentTypeFilter"></equipment-selector>
                            </div>
                            <v-switch color="success"
                                    v-model="onOnly"
                                    v-if="itemDefinition.hasOnOnlySwitch"
                                    :label="'On Only'|translate"
                            ></v-switch>

                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text style="padding-top: 0;" class="carnot-custom-view"
                             v-bind:class="[itemDefinition.renderAsReport&&itemDefinition.whiteMode ? 'carnot-custom-report-white': null]"
                             >
                    <v-layout row wrap>
                        <v-flex v-for="plot in itemDefinition.plotList" :key="itemDefinition.title+plot.id"  v-bind:class="[plot['flex-class'], 'xs12',plot['pageBreak'] ? 'page-break': null]" >
                            <data3-chart ref="plots" v-if="plot.type==='data3-chart'"
                                         :layout-overrides="plot.config['layout-overrides']"
                                         :on-only="onOnly"
                                         :x-axis="plot.config['x-axis']"
                                         :y-axis="plot.config['y-axis']"
                                         :color-axis="plot.config['color-axis']"
                                         :marker-size-axis="plot.config['marker-size-axis']"
                                         :color-axis-scale="plot.config['color-axis-scale']"
                                         :color-axis-title="plot.config['color-axis-title']"
                                         :equipment="equip"
                                         disable-responsive
                                         show-units
                                         :data-payload="plot.config['data-payload']"
                                         :independent-x="plot.config['independent-x']"
                                         :series-overrides="plot.config['series-overrides']"
                                         :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                         :date-range="range"></data3-chart>
                            <div v-if="plot.type==='html'" v-html="plot.config.html" class="ck-rendered-content"></div>
                            <div v-if="plot.type==='code'&&!plot.editDialog" v-html="plot.config.html"></div>
                            <map-widget v-if="plot.type==='map-widget'"
                                        :height="plot.config.height"
                                        :map-token="plot.config.mapToken"
                                        :map-style="plot.config.mapStyle"
                                        :pitch="plot.config.pitch"
                                        :zoom="plot.config.zoom"
                                        :center-lon="plot.config.centerLon"
                                        :center-lat="plot.config.centerLat"
                                        :markers="plot.config.markers"
                            ></map-widget>
                            <heatmap-widget v-if="plot.type==='heatmap-widget'"
                                            :date-range="range"
                                            :height="plot.config.height"
                                            :width="plot.config.width"
                                            :min="plot.config.min"
                                            :max="plot.config.max"
                                            :image-url="plot.config.imageUrl"
                                            :points="plot.config.points"
                                            :agg="plot.config.agg"
                                            :agg-opp="plot.config.aggOpp"
                                            :options="plot.config.options"
                                            :on-only="plot.config.onOnly"
                                            :player="plot.config.player"
                            ></heatmap-widget>
                            <correlation-widget v-if="plot.type==='correlation-widget'"
                                                :date-range="range"
                                                :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                :equipment-name="plot.config.equipmentName">
                            </correlation-widget>
                            <optimization-widget v-if="plot.type==='optimization-widget'"
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :exact-power-sensor="plot.config.exactPowerSensor"
                                                 :weather-sensor="plot.config.weatherSensor"
                                                 :weather-agg="plot.config.weatherAgg"
                                                 :hide-kpi="plot.config.hideKpi"
                                                 :weather-title="plot.config.weatherTitle"
                                                 :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                 :cut-off="plot.config.cutOff"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :min-power="plot.config.minPower"
                                                 :max-power="plot.config.maxPower"
                                                 :min-temp="plot.config.minTemp"
                                                 :max-temp="plot.config.maxTemp"
                                                 :agg-frequency="plot.config.aggFrequency"
                                                 :ec-mode="plot.config.ecMode"
                                                 :date-range="range"></optimization-widget>
                            <flexible-optimization-widget v-if="plot.type==='flexible-optimization-widget'"
                                                          :custom-interpolation="plot.config.customInterpolation"
                                                          :interpolation="plot.config.interpolation"
                                                          :power-sensor="plot.config.powerSensor"
                                                          :weather-sensor="plot.config.weatherSensor"
                                                          :weather-title="plot.config.weatherTitle"
                                                          :use-switch="plot.config.useSwitch"
                                                          :title="plot.config.title"
                                                          :start-date="plot.config.startDate"
                                                          :end-date="plot.config.endDate"
                                                          :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                          :cut-off="plot.config.cutOff"
                                                          :switch-sensor="plot.config.switchSensor"
                                                          :show-calc="plot.config.showCalc"
                                                          :min-temp="plot.config.minTemp"
                                                          :hide-kpi="plot.config.hideKpi"
                                                          :max-temp="plot.config.maxTemp"
                                                          :ec-mode="plot.config.ecMode"
                                                          :data3query="plot.config.data3query"
                                                          :date-range="range"></flexible-optimization-widget>
                            <cop-savings-widget v-if="plot.type==='cop-savings-widget'"
                                                :custom-interpolation="plot.config.customInterpolation"
                                                :interpolation="plot.config.interpolation"
                                                :power-sensor="plot.config.powerSensor"
                                                :cooling-load-sensor="plot.config.coolingLoadSensor"
                                                :title="plot.config.title"
                                                :start-date="plot.config.startDate"
                                                :end-date="plot.config.endDate"
                                                :hide-kpi="plot.config.hideKpi"
                                                :cut-off="plot.config.cutOff"
                                                :switch-sensor="plot.config.switchSensor"
                                                :use-switch="plot.config.useSwitch"
                                                :min-power="plot.config.minPower"
                                                :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                :max-power="plot.config.maxPower"
                                                :use-filter="plot.config.useFilter"
                                                :filter-sensor="plot.config.filterSensor"
                                                :max-filter="plot.config.maxFilter"
                                                :min-filter="plot.config.minFilter"
                                                :min-cooling-load="plot.config.minCoolingLoad"
                                                :max-cooling-load="plot.config.maxCoolingLoad"
                                                :agg-frequency="plot.config.aggFrequency"
                                                :show-mean-cop="plot.config.showMeanCop"
                                                :ec-mode="plot.config.ecMode"
                                                :date-range="range"></cop-savings-widget>
                            <fault-breakdown-widget v-if="plot.type==='fdd-breakdown-widget'"
                                                    :vertical="plot.config.vertical"
                                                    :hide-table="plot.config.hideTable"
                                                    :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                    :date-range="range"></fault-breakdown-widget>
                            <fault-eval-widget v-if="plot.type==='fault-eval-widget'"
                                               :rule="plot.config.rule"
                                               :title="plot.config.title"
                                               :value="plot.config.value"
                                               :equipment-name="plot.config.equipmentName"
                                               :relevant-variables="plot.config.relevantVariables"
                                               :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                               :on-only="plot.config.onOnly"
                                               :show-cost="plot.config.showCost"
                                               :date-range="range"></fault-eval-widget>
                          <staging-profile-widget v-if="plot.type==='staging-profile-widget'"
                                                  :title="plot.config.title"
                                                  :x-title="plot.config.xTitle"
                                                  :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                  :y-title="plot.config.yTitle"
                                                  :date-range="range"></staging-profile-widget>
                            <cooling-load-forecast-widget v-if="plot.type==='cooling-load-forecast-widget'"
                                                  :title="plot.config.title"
                                                  :actual-observed-value-legend="plot.config.actualObservedValueLegend"
                                                  :confidence-interval-legend="plot.config.confidenceIntervalLegend"
                                                  :expected-value-legend="plot.config.expectedValueLegend"
                                                  :fitted-value-legend="plot.config.fittedValueLegend"
                                                  :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                  :x-title="plot.config.xTitle"
                                                  :y-title="plot.config.yTitle"
                                                  :result-name="plot.config.resultName"
                                                  ></cooling-load-forecast-widget>
                            <chiller-sequencing-fla-widget v-if="plot.type==='chiller-sequencing-fla-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                    :y-title="plot.config.yTitle"
                                                    :dateRange="range"
                                                ></chiller-sequencing-fla-widget>
                            <chiller-sequencing-delta-widget v-if="plot.type==='chiller-sequencing-delta-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :dateRange="range"
                                                    :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                ></chiller-sequencing-delta-widget>
                            <cooling-load-vs-oat-widget v-if="plot.type==='cooling-load-vs-oat-widget'"
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :dateRange="range"
                                                    :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                            ></cooling-load-vs-oat-widget>
                            <bms-widget v-if="plot.type==='bms-widget'"
                                        :title="plot.config.title"
                                        :latest-only="plot.config.latestOnly"
                                        :svg="plot.config.svg"></bms-widget>
                            <svg-widget v-if="plot.type==='svg-widget'"
                                        :data3query="plot.config.data3query"
                                        :date-range="range"
                                        :include-issues="plot.config.includeIssues"
                                        :include-maintenance="plot.config.includeMaintenance"
                                        :svg="plot.config.svg"></svg-widget>
                            <forge-viewer-widget v-if="plot.type==='forge-viewer-widget'"
                                                 :selected-items="[plot.config.selectedItemID]"
                                                 :selection-color="plot.config.selectionColor"
                                                 :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                 :url="plot.config.url" :height="plot.config.height"></forge-viewer-widget>
                            <forge-viewer-heatmap-widget
                                v-if="plot.type==='forge-viewer-heatmap-widget'"
                                :url="plot.config.url"
                                :date-range="range"
                                :points="plot.config.points"
                                :surface-id="plot.config.surfaceId"
                                :floor-name="plot.config.floorName"
                                :agg="plot.config.agg"
                                :agg-opp="plot.config.aggOpp"
                                :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                :on-only="plot.config.onOnly"
                                :height="plot.config.height"></forge-viewer-heatmap-widget>
                            <maintenance-summary-widget v-if="plot.type==='maintenance-summary-widget'"
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                        :height="plot.config.height"
                                                        :date-range="range"
                            ></maintenance-summary-widget>
                            <issue-summary-widget v-if="plot.type==='issue-summary-widget'"
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :title3="plot.config.title3"
                                                        :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                        :height="plot.config.height"
                                                        :date-range="range"
                            ></issue-summary-widget>
                            <tree-map-widget v-if="plot.type==='tree-map-widget'"
                                             :title="plot.config.title"
                                             :power-sensor="plot.config.powerSensor"
                                             :agg-frequency="plot.config.aggFrequency"
                                             :height="plot.config.height"
                                             :unit="plot.config.unit"
                                             :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                             :date-range="range"
                            ></tree-map-widget>
                            <cost-breakdown-widget v-if="plot.type==='cost-breakdown-widget'"
                                                   :height="plot.config.height"
                                                   :leftmarg="plot.config.leftmarg"
                                                   :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                                   :date-range="range"></cost-breakdown-widget>
                            <custom-ec-widget v-if="plot.type==='custom-ec-widget'"
                                              :config="plot.config.config"
                                              :white-mode="itemDefinition.renderAsReport&&itemDefinition.whiteMode"
                                              :height="plot.config.height"
                            ></custom-ec-widget>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions v-if="!embeddedMode">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-if="$refs.plots"
                           @click="exportAll()"
                    >
                        {{'Export charts as PDF'|translate}}
                    </v-btn>
                    <v-btn color="primary" class="mr-2" v-if="!itemDefinition.renderAsReport&&!reportIsPrinting" id="printer"
                           @click="printAll()"
                    >
                        {{'Export all as PDF'|translate}}
                    </v-btn>
                    <v-btn color="primary" @click="printReportPDF()" v-if="itemDefinition.renderAsReport&&!reportIsPrinting" id="printer">
                        {{'Export all as PDF'|translate}}
                    </v-btn>
                    <v-progress-circular indeterminate class="mr-5 ml-5" v-if="reportIsPrinting" size="18"></v-progress-circular>
                    <v-btn color="primary" @click="openInEditor(itemDefinition.id)" v-if="$can('update', 'Config')&&itemDefinition.id">
                        {{'Edit'|translate}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import DateRangeSelector from '../../components/DateRangeSelector'
    import EquipmentSelector from '../../components/EquipmentSelector'
    import exportAllToPDF from '../../components/mixins/exportAllToPDF'
    import printer from "../../components/mixins/printer";
    import reportPrinter from '../../components/mixins/reportPrinter'
    import Data3Chart from "../../components/Data3Chart";
    import MapWidget from "../../components/widgets/MapWidget";
    import HeatmapWidget from "../../components/widgets/HeatmapWidget";
    import CorrelationWidget from "../../components/widgets/CorrelationWidget";
    import OptimizationWidget from "../../components/widgets/OptimizationWidget";
    import FaultBreakdownWidget from "../../components/widgets/FaultBreakdownWidget";
    import CopSavingsWidget from "../../components/widgets/CopSavingsWidget";
    import FaultEvalWidget from "../../components/widgets/FaultEvalWidget";
    import StagingProfileWidget from "../../components/widgets/StagingProfileWidget";
    import CoolingLoadForecastWidget from '../../components/widgets/CoolingLoadForecastWidget'
    import ChillerSequencingFlaWidget from '../../components/widgets/ChillerSequencingFLAWidget'
    import ChillerSequencingDeltaWidget from '../../components/widgets/ChillerSequencingDeltaWidget'
    import CoolingLoadVsOatWidget from '../../components/widgets/CoolingLoadVsOatWidget'
    import BmsWidget from "@/components/widgets/BmsWidget";
    import ForgeViewerWidget from "@/components/widgets/ForgeViewerWidget";
    import ForgeViewerHeatmapWidget from "@/components/widgets/ForgeViewerHeatmapWidget";
    import MaintenanceSummaryWidget from "@/components/widgets/MaintenanceSummaryWidget";
    import CostBreakdownWidget from "@/components/widgets/CostBreakdownWidget";
    import SvgWidget from "@/components/widgets/SvgWidget";
    import IssueSummaryWidget from "@/components/widgets/IssueSummaryWidget";
    import TreeMapWidget from "@/components/widgets/TreeMapWidget";
    import FlexibleOptimizationWidget from "@/components/widgets/FlexibleOptimizationWidget";
    import CustomEcWidget from "../../components/widgets/CustomEcWidget";
    import moment from 'moment'

    export default {
        name: 'PlotList',
        components: {
            FaultEvalWidget,
            EquipmentSelector,
            DateRangeSelector,
            Data3Chart,
            MapWidget,
            HeatmapWidget,
            CorrelationWidget,
            OptimizationWidget,
            FaultBreakdownWidget,
            CopSavingsWidget,
            StagingProfileWidget,
            CoolingLoadForecastWidget,
            ChillerSequencingFlaWidget,
            ChillerSequencingDeltaWidget,
            CoolingLoadVsOatWidget,
            BmsWidget,
            ForgeViewerWidget,
            ForgeViewerHeatmapWidget,
            MaintenanceSummaryWidget,
            CostBreakdownWidget,
            SvgWidget,
            IssueSummaryWidget,
            TreeMapWidget,
            FlexibleOptimizationWidget,
            CustomEcWidget
        },
        props: {
            itemDefinition: {type: Object, default: null},
            rangeOverride:{type: Object, default: null},
            embeddedMode:{type: Boolean, default: false},

        },
        mixins:[exportAllToPDF,printer,reportPrinter],
        data() {
            return {
                equip: null,
                range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                onOnly: false,
                reportIsPrinting:false,
                interval:null,
            }
        },
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },
        },
        watch: {
            range () {
                this.updateQueryString()
            },
            itemDefinition(){
                this.runCleanup()
            }
        },
        methods:{
            openInEditor(id){
                window.open('/custom-view-builder?view='+id)
            },
          async exportAll() {
            let title = this.facility_name + "=" + this.range.start
            this.exportAllItems(this.$refs.plots, title);
          },
            async printAll() {
                let title = this.facility_name + "=" + this.range.start
                this.reportIsPrinting = true
                await this.printPage('.carnot-custom-view', title)
                this.reportIsPrinting = false
            },
            async printReportPDF() {
                this.reportIsPrinting = true
                await this.generateReportPDF(this.itemDefinition.title, this.itemDefinition.subtitle,this.itemDefinition.whiteMode,this.itemDefinition.brandName,this.itemDefinition.disableCoverPage,this.itemDefinition.customLogo)
                this.reportIsPrinting = false
          },
            updateQueryString () {
                    this.$router.replace({
                        path: this.$router.currentRoute.path,
                        query: {
                            rangeStart: this.range.start,
                            rangeEnd: this.range.end,
                        }
                    }).catch(err => {})
                },

            runCleanup(){
                if(this.rangeOverride){
                    this.range = this.rangeOverride
                } else {
                    let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                    let rangeStart = _.get(this.$route.query, 'rangeStart', null)
                    let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
                    if (this.itemDefinition.defaultRange&&this.itemDefinition.defaultRange==="live"){
                        let me = this
                        me.range={start:moment().subtract(4,"hours").format('YYYY-MM-DD HH:mm:ss'),end:moment().format('YYYY-MM-DD HH:mm:ss')}
                        me.interval=setInterval(function() {
                            me.range={start:moment().subtract(4,"hours").format('YYYY-MM-DD HH:mm:ss'),end:moment().format('YYYY-MM-DD HH:mm:ss')}
                        }, Math.round(3600000/me.$store.state.pointsListStore.pointsList.sampling_freq));
                    } else if (!!rangeStart) {
                        this.range = {start: rangeStart, end: rangeEnd}
                    } else if (this.itemDefinition.defaultRange&&this.itemDefinition.defaultRange!==""&&this.itemDefinition.defaultRange!=="30 days"){
                        if(this.itemDefinition.defaultRange==="this range"){
                            this.range=JSON.parse(JSON.stringify(this.itemDefinition.range))
                        } else {
                            let baseDate=moment()
                            if(maxDate){
                                baseDate=moment(maxDate)
                            }
                            let startDate=baseDate.clone().subtract(30, "days")
                            if(this.itemDefinition.defaultRange==="current week"){
                                startDate=baseDate.clone().startOf("week")
                            } else if(this.itemDefinition.defaultRange==="current month"){
                                startDate=baseDate.clone().startOf("month")
                            } else if(this.itemDefinition.defaultRange==="today"){
                                startDate=baseDate.clone().startOf("day")
                            } else if(this.itemDefinition.defaultRange==="current year"){
                                startDate=baseDate.clone().startOf("year")
                            } else if(this.itemDefinition.defaultRange==="last week"){
                                baseDate=baseDate.subtract(1,"week").endOf("week")
                                startDate=baseDate.clone().startOf("week")
                            }else if(this.itemDefinition.defaultRange==="last month"){
                                baseDate=baseDate.subtract(1,"month").endOf("month")
                                startDate=baseDate.clone().startOf("month")
                            }else if(this.itemDefinition.defaultRange==="yesterday"){
                                baseDate=baseDate.subtract(1,"day").endOf("day")
                                startDate=baseDate.clone().startOf("day")
                            }else if(this.itemDefinition.defaultRange==="last year"){
                                baseDate=baseDate.subtract(1,"year").endOf("year")
                                startDate=baseDate.clone().startOf("year")
                            }
                            if(this.itemDefinition.defaultRange==="yesterday"||this.itemDefinition.defaultRange==="today"){
                                this.range={start:startDate.format('YYYY-MM-DD HH:mm:ss'),end:baseDate.format('YYYY-MM-DD HH:mm:ss')}
                            } else {
                                this.range={start:startDate.format('YYYY-MM-DD'),end:baseDate.format('YYYY-MM-DD')}
                            }
                        }
                    }else if(maxDate){
                        this.range={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
                    }
                }
            }
        },
        beforeDestroy: function(){
            clearInterval(this.interval)
        },
        beforeMount() {
            this.runCleanup()
        }
    }
</script>
<style>
    .carnot-custom-report{
        width: 900px;
        margin-left: auto;
        margin-right: auto;
    }
    .carnot-custom-report-white{
        background-color: white !important;
    }
    :root {
        --ck-color-image-caption-background: hsl(0, 0%, 97%);
        --ck-color-image-caption-text: hsl(0, 0%, 20%);
        --ck-color-mention-background: hsla(341, 100%, 30%, 0.1);
        --ck-color-mention-text: hsl(341, 100%, 30%);
        --ck-color-table-caption-background: hsl(0, 0%, 97%);
        --ck-color-table-caption-text: hsl(0, 0%, 20%);
        --ck-highlight-marker-blue: hsl(201, 97%, 72%);
        --ck-highlight-marker-green: hsl(120, 93%, 68%);
        --ck-highlight-marker-pink: hsl(345, 96%, 73%);
        --ck-highlight-marker-yellow: hsl(60, 97%, 73%);
        --ck-highlight-pen-green: hsl(112, 100%, 27%);
        --ck-highlight-pen-red: hsl(0, 85%, 49%);
        --ck-image-style-spacing: 1.5em;
        --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
        --ck-todo-list-checkmark-size: 16px;
    }
    /* ckeditor5-image/theme/imagecaption.css */
    .ck-rendered-content .image > figcaption {
        display: table-caption;
        caption-side: bottom;
        word-break: break-word;
        color: var(--ck-color-image-caption-text);
        background-color: var(--ck-color-image-caption-background);
        padding: .6em;
        font-size: .75em;
        outline-offset: -1px;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-left,
    .ck-rendered-content .image-style-block-align-right {
        max-width: calc(100% - var(--ck-image-style-spacing));
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-left,
    .ck-rendered-content .image-style-align-right {
        clear: none;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-side {
        float: right;
        margin-left: var(--ck-image-style-spacing);
        max-width: 50%;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-left {
        float: left;
        margin-right: var(--ck-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-center {
        margin-left: auto;
        margin-right: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-align-right {
        float: right;
        margin-left: var(--ck-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-right {
        margin-right: 0;
        margin-left: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-style-block-align-left {
        margin-left: 0;
        margin-right: auto;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content p + .image-style-align-left,
    .ck-rendered-content p + .image-style-align-right,
    .ck-rendered-content p + .image-style-side {
        margin-top: 0;
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-left,
    .ck-rendered-content .image-inline.image-style-align-right {
        margin-top: var(--ck-inline-image-style-spacing);
        margin-bottom: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-left {
        margin-right: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-image/theme/imagestyle.css */
    .ck-rendered-content .image-inline.image-style-align-right {
        margin-left: var(--ck-inline-image-style-spacing);
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-tiny {
        font-size: .7em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-small {
        font-size: .85em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-big {
        font-size: 1.4em;
    }
    /* ckeditor5-font/theme/fontsize.css */
    .ck-rendered-content .text-huge {
        font-size: 1.8em;
    }
    /* ckeditor5-horizontal-line/theme/horizontalline.css */
    .ck-rendered-content hr {
        margin: 15px 0;
        height: 4px;
        background: hsl(0, 0%, 87%);
        border: 0;
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-yellow {
        background-color: var(--ck-highlight-marker-yellow);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-green {
        background-color: var(--ck-highlight-marker-green);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-pink {
        background-color: var(--ck-highlight-marker-pink);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .marker-blue {
        background-color: var(--ck-highlight-marker-blue);
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .pen-red {
        color: var(--ck-highlight-pen-red);
        background-color: transparent;
    }
    /* ckeditor5-highlight/theme/highlight.css */
    .ck-rendered-content .pen-green {
        color: var(--ck-highlight-pen-green);
        background-color: transparent;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image {
        display: table;
        clear: both;
        text-align: center;
        margin: 0.9em auto;
        min-width: 50px;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
        min-width: 100%;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline {
        /*
         * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).;
         * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.
         * This strange behavior does not happen with inline-flex.
         */
        display: inline-flex;
        max-width: 100%;
        align-items: flex-start;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline picture {
        display: flex;
    }
    /* ckeditor5-image/theme/image.css */
    .ck-rendered-content .image-inline picture,
    .ck-rendered-content .image-inline img {
        flex-grow: 1;
        flex-shrink: 1;
        max-width: 100%;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized {
        max-width: 100%;
        display: block;
        box-sizing: border-box;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized img {
        width: 100%;
    }
    /* ckeditor5-image/theme/imageresize.css */
    .ck-rendered-content .image.image_resized > figcaption {
        display: block;
    }
    /* ckeditor5-block-quote/theme/blockquote.css */
    .ck-rendered-content blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        margin-right: 0;
        font-style: italic;
        border-left: solid 5px hsl(0, 0%, 80%);
    }
    /* ckeditor5-block-quote/theme/blockquote.css */
    .ck-rendered-content[dir="rtl"] blockquote {
        border-left: 0;
        border-right: solid 5px hsl(0, 0%, 80%);
    }
    /* ckeditor5-basic-styles/theme/code.css */
    .ck-rendered-content code {
        background-color: hsla(0, 0%, 78%, 0.3);
        padding: .15em;
        border-radius: 2px;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table {
        margin: 0.9em auto;
        display: table;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        height: 100%;
        border: 1px double hsl(0, 0%, 70%);
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table td,
    .ck-rendered-content .table table th {
        min-width: 2em;
        padding: .4em;
        border: 1px solid hsl(0, 0%, 75%);
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content .table table th {
        font-weight: bold;
        background: hsla(0, 0%, 0%, 5%);
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content[dir="rtl"] .table th {
        text-align: right;
    }
    /* ckeditor5-table/theme/table.css */
    .ck-rendered-content[dir="ltr"] .table th {
        text-align: left;
    }
    /* ckeditor5-table/theme/tablecaption.css */
    .ck-rendered-content .table > figcaption {
        display: table-caption;
        caption-side: top;
        word-break: break-word;
        text-align: center;
        color: var(--ck-color-table-caption-text);
        background-color: var(--ck-color-table-caption-background);
        padding: .6em;
        font-size: .75em;
        outline-offset: -1px;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break {
        position: relative;
        clear: both;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break::after {
        content: '';
        position: absolute;
        border-bottom: 2px dashed hsl(0, 0%, 77%);
        width: 100%;
    }
    /* ckeditor5-page-break/theme/pagebreak.css */
    .ck-rendered-content .page-break__label {
        position: relative;
        z-index: 1;
        padding: .3em .6em;
        display: block;
        text-transform: uppercase;
        border: 1px solid hsl(0, 0%, 77%);
        border-radius: 2px;
        font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;
        font-size: 0.75em;
        font-weight: bold;
        color: hsl(0, 0%, 20%);
        background: hsl(0, 0%, 100%);
        box-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    /* ckeditor5-media-embed/theme/mediaembed.css */
    .ck-rendered-content .media {
        clear: both;
        margin: 0.9em 0;
        display: block;
        min-width: 15em;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list {
        list-style: none;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list li {
        margin-bottom: 5px;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list li .todo-list {
        margin-top: 5px;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input {
        -webkit-appearance: none;
        display: inline-block;
        position: relative;
        width: var(--ck-todo-list-checkmark-size);
        height: var(--ck-todo-list-checkmark-size);
        vertical-align: middle;
        border: 0;
        left: -25px;
        margin-right: -15px;
        right: 0;
        margin-left: 0;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input::before {
        display: block;
        position: absolute;
        box-sizing: border-box;
        content: '';
        width: 100%;
        height: 100%;
        border: 1px solid hsl(0, 0%, 20%);
        border-radius: 2px;
        transition: 250ms ease-in-out box-shadow, 250ms ease-in-out background, 250ms ease-in-out border;
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input::after {
        display: block;
        position: absolute;
        box-sizing: content-box;
        pointer-events: none;
        content: '';
        left: calc( var(--ck-todo-list-checkmark-size) / 3 );
        top: calc( var(--ck-todo-list-checkmark-size) / 5.3 );
        width: calc( var(--ck-todo-list-checkmark-size) / 5.3 );
        height: calc( var(--ck-todo-list-checkmark-size) / 2.6 );
        border-style: solid;
        border-color: transparent;
        border-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;
        transform: rotate(45deg);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input[checked]::before {
        background: hsl(126, 64%, 41%);
        border-color: hsl(126, 64%, 41%);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label > input[checked]::after {
        border-color: hsl(0, 0%, 100%);
    }
    /* ckeditor5-list/theme/todolist.css */
    .ck-rendered-content .todo-list .todo-list__label .todo-list__label__description {
        vertical-align: middle;
    }
    /* ckeditor5-language/theme/language.css */
    .ck-rendered-content span[lang] {
        font-style: italic;
    }
    /* ckeditor5-code-block/theme/codeblock.css */
    .ck-rendered-content pre {
        padding: 1em;
        color: hsl(0, 0%, 20.8%);
        background: hsla(0, 0%, 78%, 0.3);
        border: 1px solid hsl(0, 0%, 77%);
        border-radius: 2px;
        text-align: left;
        direction: ltr;
        tab-size: 4;
        white-space: pre-wrap;
        font-style: normal;
        min-width: 200px;
    }
    /* ckeditor5-code-block/theme/codeblock.css */
    .ck-rendered-content pre code {
        background: unset;
        padding: 0;
        border-radius: 0;
    }
    /* ckeditor5-mention/theme/mention.css */
    .ck-rendered-content .mention {
        background: var(--ck-color-mention-background);
        color: var(--ck-color-mention-text);
    }
    @media print {
        /* ckeditor5-page-break/theme/pagebreak.css */
        .ck-rendered-content .page-break {
            padding: 0;
        }
        /* ckeditor5-page-break/theme/pagebreak.css */
        .ck-rendered-content .page-break::after {
            display: none;
        }
    }
</style>
